export const environment = {
  production: false,
  ENABLE_DEBUG: false,
  RESERVE_URL: 'https://api-dev-tablereservation.grupomadero.com.br/api/v1',
  TOKEN_URL: 'https://authsts-dev.grupomadero.com.br/connect',
};
